import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addmsgSharing, returnmsgSharing, updatenmsgSharing } from "@/api/dataAll/msgSharing";
export default {
  name: "addMsgSharing",
  prop: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      form: {
        classify: ''
      }
    }, _defineProperty(_ref, "id", ""), _defineProperty(_ref, "rules", {// game: [{ required: true, message: "游戏", trigger: "blur" }],
      // platform: [{ required: true, message: "平台", trigger: "blur" }],
      // parameter: [{ required: true, message: "参数", trigger: "blur" }],
    }), _defineProperty(_ref, "formLabelWidth", "80px"), _ref;
  },
  created: function created() {
    this.searchMark = {};
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(id, num) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$returnmsgShari, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (num == 1) {
                  _this.titleName = "新增分类";
                  _this.form = {};
                }

                _this.id = id;

                if (!(id != "t")) {
                  _context.next = 16;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 16;
                  break;
                }

                _this.titleName = "修改分类";
                _this.id = id;
                tid = {
                  id: id
                };
                _context.next = 10;
                return returnmsgSharing(tid);

              case 10:
                _yield$returnmsgShari = _context.sent;
                data = _yield$returnmsgShari.data;
                _this.form.classify = data.classify;
                _this.searchMark.classify = data.classify;
                _this.searchMark.id = data.id;

                _this.$set(_this.form, _this.form.classify, "");

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    textChange: function textChange(val) {
      //  this.form.textarea2= val
      this.searchMark.classify = val;
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      if (this.titleName == "新增分类") {
        this.searchMark.kind = 1;
        addmsgSharing(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message);

            _this2.$emit("refreshDataList");

            _this2.resetForm("ruleForm");
          } else {
            Message.warning(res.message);

            _this2.resetForm("ruleForm");
          }
        });
      }

      if (this.titleName == "修改分类") {
        updatenmsgSharing(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message);

            _this2.$emit("refreshDataList");

            _this2.resetForm("ruleForm");
          } else {
            Message.warning(res.message);
          }
        });
      }
    },
    clearData: function clearData() {
      this.form = {};
      this.searchMark = {};
    }
  }
};